import React from "react";

const PrerequisChips = ({ requis }) => {
  if (!requis || requis.length === 0) return null;

  return (
    <div className="regles-calcul__prerequis">
      <span className="regles-calcul__prerequis-label">
        <i className="fas fa-key mr-2" />
        Prérequis
      </span>
      <div className="regles-calcul__prerequis-list">
        {requis.map((r) => (
          <span key={r} className="regles-calcul__chip">
            {r}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PrerequisChips;
